import { Box, Button, Center, Flex, IconButton, Image, Link, Skeleton, Spacer, useDisclosure } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FaCrown } from 'react-icons/fa';
import { RiMenu3Fill } from 'react-icons/ri';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import { isEmptyObject } from '../../../helper/utils/isEmptyObject';
import { urlNavigate } from '../../../helper/utils/navigation';
import getStaticAsset from '../../../helper/utils/utilsStaticAsset';
import useScrollHandler from '../../../hooks/useScrollHandler';
import usePages from '../hooks/usePages';
import DrawerMenu from './DrawerMenu';
import ModalLogIn from './ModalLogIn';

export default function HeaderSales() {
    const navigate = useNavigate();
    const isVerifiedWaiver = (localStorage.getItem('isVerifiedWaiver') || 'false') === 'true';

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenVerify, onClose: onCloseVerify, onOpen: onOpenVerify } = useDisclosure();
    const { page } = usePages();
    const { y } = useScrollHandler();
    const [params, setParams] = useSearchParams();

    const menus = (page['products'] || {})['items'] || [];
    const isActive = y > 300;

    useEffect(() => {
        const isOpenLogin = params.get('isOpenLogin') === 'true' || params.get('isopenLogin') === 'true';

        if (isOpenLogin) {
            onOpenVerify();
        }
    }, [params]);

    return (
        <Box w='full' bg='white' h='75px' p={3} px={{ base: 3, md: 5 }} transition='all 0.35s ease-in-out' rounded={isActive ? 'none' : 'xl'} position={isActive ? 'fixed' : 'sticky'} top={0} left={0} zIndex={999} boxShadow={isActive ? 'xl' : 'none'}>
            <Center w='full' h='full'>
                <Flex w='full' alignItems='center' justifyContent='space-between'>
                    {isEmptyObject(page) ? (
                        <Skeleton w='125px' h='50px'></Skeleton>
                    ) : (
                        <Box>
                            <Image src={getStaticAsset(page['logo'])} w='80px' h='90%' fit='contain' />
                        </Box>
                    )}
                    <Box w='full' mr={{ base: 0, lg: 12 }} display={{ base: 'none', lg: 'block' }}>
                        <Flex w='full' alignItems='center' justifyContent='center' gap={4}>
                            <Link
                                as={RouterLink}
                                to={`${urlNavigate('online-sales', 'home')}`}
                                textTransform='capitalize'
                                color='gray.400'
                                fontWeight={400}
                                transition='all 0.35s ease-in-out'
                                _hover={{ color: 'black' }}
                                onClick={() => {
                                    localStorage.setItem('product', '{}');
                                }}>
                                Home
                            </Link>
                            {menus?.map((product, index) => {
                                const { title, cta } = product;

                                return (
                                    <Link
                                        key={index}
                                        as={RouterLink}
                                        to={`${urlNavigate(cta)}`}
                                        textTransform='capitalize'
                                        color='gray.400'
                                        fontWeight={400}
                                        transition='all 0.35s ease-in-out'
                                        _hover={{ color: 'black' }}
                                        onClick={() => {
                                            localStorage.setItem('product', JSON.stringify(product));
                                        }}>
                                        {title}
                                    </Link>
                                );
                            })}
                        </Flex>
                    </Box>
                    <Spacer />
                    {/* <Box mx={3}>
                        <LanguageSwitcher />
                    </Box> */}
                    <Button
                        mx={2}
                        fontSize='14px'
                        fontWeight={700}
                        colorScheme='red'
                        py={6}
                        px={7}
                        leftIcon={<FaCrown />}
                        onClick={() => {
                            setParams({
                                date: params.get('date') || '',
                                productId: params.get('productId') || '',
                                isShowDetail: (params.get('productId') || '') !== '',
                                type: params.get('type') || '',
                                callback: urlNavigate('dashboard', 'membership'),
                            });

                            if (!isVerifiedWaiver) {
                                onOpenVerify();
                                return;
                            }

                            navigate(urlNavigate('dashboard'));
                        }}>
                        {isVerifiedWaiver ? 'Dashboard' : 'Be Our Member'}
                    </Button>

                    {/* <PopupTransactionHistory /> */}

                    <Box mx={{ base: 0, md: 2 }}>
                        <IconButton icon={<RiMenu3Fill />} variant='solid' colorScheme='primary' onClick={onOpen} size='lg' />
                        <DrawerMenu isOpen={isOpen} onClose={onClose} menus={menus} />
                    </Box>
                </Flex>
            </Center>

            <ModalLogIn isOpen={isOpenVerify} onClose={onCloseVerify} />
        </Box>
    );
}
